<template>
  <div class="home page">
    <div class="text-update-content">Home Page!.</div>
  </div>
</template>

<script>

export default {
  name: 'IndexPage',

  components: {
  },

  data: () => {
    return {
      // msg: 'Welcome to Index!!!',
      isShownModal: false,
      inputError: false,
      checkboxState: false,

      pagination: {
        limit: 20,
        offset: 0,
        total: 60
      }
    }
  },

  methods: {

  }
}
</script>
<style scoped>
  .text-update-content {
    text-align: center;
    font-size: 22px;
    line-height: 100px;
  }
</style>
